/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1ClassroomdisciplineClassModulesIdMutationRequest,
  PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
  PutApiV1ClassroomdisciplineClassModulesIdPathParams,
  PutApiV1ClassroomdisciplineClassModulesId400,
  PutApiV1ClassroomdisciplineClassModulesId401,
  PutApiV1ClassroomdisciplineClassModulesId404,
  PutApiV1ClassroomdisciplineClassModulesId500,
} from "../../types/classPlanningClassModuleController/PutApiV1ClassroomdisciplineClassModulesId.ts";

function getPutApiV1ClassroomdisciplineClassModulesIdUrl(
  id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/classroomdiscipline/class-modules/${id}` as const,
  };
  return res;
}

/**
 * @description Edição não-destrutiva: atualiza o cabeçalho, os campos das aulas de disciplinas existentes (sala, professor, tipo e flags) e permite ADICIONAR novas Turmas e Disciplinas. Bloqueia (400) remover Turma/Disciplina, alterar quantidade/recorrência de disciplina existente, ou editar Módulo com aulas já realizadas. **(Requer Authorization para autenticação)**
 * @summary Editar Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules/:id}
 */
export async function putApiV1ClassroomdisciplineClassModulesId(
  id: PutApiV1ClassroomdisciplineClassModulesIdPathParams["id"],
  data?: PutApiV1ClassroomdisciplineClassModulesIdMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1ClassroomdisciplineClassModulesIdMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ClassroomdisciplineClassModulesId400
      | PutApiV1ClassroomdisciplineClassModulesId401
      | PutApiV1ClassroomdisciplineClassModulesId404
      | PutApiV1ClassroomdisciplineClassModulesId500
    >,
    PutApiV1ClassroomdisciplineClassModulesIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1ClassroomdisciplineClassModulesIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
